<template>
  <div class="container" :style="{ backgroundImage: backImg }">
    <div class="head">
      <div class="head-l">
        <img src="../assets/导航logo.png" />
        <div class="l-line"></div>
        <span>企业微信开发服务商</span>
      </div>
      <div class="head-r">
        <span @click="url">微炬云首页</span>
        <span @click="urlHelp">帮助与文档</span>
        <div class="ziXun">
          <span>咨询电话：</span>400-113-0200
        </div>
      </div>
    </div>
    <div class="main">
      <div>
        <div class="body">
          <div class="b_title">
            <p></p>
            <p>总代理商登录</p>
          </div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item label prop="name">
              <el-input clearable v-model="ruleForm.name" placeholder="总代理商账号"><i slot="prefix"
                  class="iconfont icon-user_icon"></i></el-input>
            </el-form-item>
            <el-form-item label prop="mima">
              <el-input clearable v-model="ruleForm.mima" show-password placeholder="登录密码"><i slot="prefix"
                  class="iconfont icon-password_icon"></i></el-input>
            </el-form-item>
            <el-form-item label prop="yzm">
              <el-input clearable v-model="ruleForm.yzm" placeholder="验证码"><i slot="prefix"
                  class="iconfont icon-check_icon"></i></el-input>
            </el-form-item>
            <div class="login-code" @click="abcou">
              <img :src="imgCode" class="sson" />
            </div>
            <el-button type="primary login-btn" @click="submitForm()">登录</el-button>
          </el-form>
        </div>
        <div class="footer">
          <div class="footer-t">
            <ul class="footer-ul">
              <li>
                <a href="https://www.weijub.com/index/index/index">首页</a>
              </li>
              <li>|</li>
              <li>
                <a href="https://www.weijub.com/index/index/product">微炬云产品</a>
              </li>
              <li>|</li>
              <li>
                <a href="https://www.weijub.com/index/index/plan">行业解决方案</a>
              </li>
              <li>|</li>
              <li>
                <a href="https://www.weijub.com/index/index/channel">渠道合作</a>
              </li>
              <li>|</li>
              <li>
                <a href="https://www.weijub.com/index/index/news?category_id=15">营销干货</a>
              </li>
              <li>|</li>
              <li>
                <a href="https://www.weijub.com/index/index/channel_center">渠道中心</a>
              </li>
              <li>|</li>
              <li>
                <a href="https://www.weijub.com/index/index/about">关于我们</a>
              </li>
            </ul>
          </div>
          <div class="footer-b">
            Copyright © 2013-2023 www.weijub.com All Rights Reserved
            上海微炬云企业发展有限公司版权所有 沪ICP备20021369号-1
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SIdentify from "../components/sidentify";
import md5 from "js-md5";
import qs from "qs";
export default {
  data() {
    return {
      ruleForm: {
        name: "",
        mima: "",
        yzm: "",
        sjs: "",
      },
      rules: {
        name: [
          { required: true, message: '账号不能为空！', trigger: 'blur' },
        ],
        mima: [
          { required: true, message: '密码不能为空！', trigger: 'blur' }
        ],
        yzm: [
          { required: true, message: '验证码不能为空！', trigger: 'blur' }
        ],
      },
      imgCode: "https://api.weijub.com/api/user/newCode",   //验证码图片
      // userdetailShow: false, //回车
      title: {},
      backImg: 'url(' + require('../assets/tagent_back.png') + ')'
    };
  },
  mounted() {
    this.abcou();
    if (window.sessionStorage.getItem("title")) {
      let title = JSON.parse(window.sessionStorage.getItem("title"));
      this.title = title;
      var a = document.title;
      document.title = title[0].website + "-" + a;
    }
  },
  components: {
    // 验证码
    // SIdentify
  },
  created() {
    // this.refreshCode();//验证码
    this.keyupSubmit(); //回车
  },
  methods: {
    url() {
      location.href = "https://www.weijub.com";
    },
    urlHelp() {
      location.href = "https://www.weijub.com/index/index/help.html?id=59";
    },
    abcou() {
      this.ruleForm.sjs = Math.round(Math.random() * 100000000);
      var obj = this.ruleForm.sjs;
      this.imgCode = "https://api.weijub.com/api/user/newCode?id=" + obj + "";
    },
    keyupSubmit() {
      document.onkeydown = (e) => {
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.submitForm();
        }
      };
    },
    // detailShow() {
    //   this.userdetailShow = true;
    // },
    submitForm() {
      this.axios
        .post(
          "/api/user/verfycode",
          qs.stringify({
            code: this.ruleForm.yzm,
            id: this.ruleForm.sjs,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.axios
              .post(
                "/api/user/totalLogin",
                qs.stringify({
                  username: this.ruleForm.name,
                  password: this.$md5(this.ruleForm.mima),
                }),
                {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                  },
                }
              )
              .then((res) => {
                if (res.data.code == 1) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  var shuiji = res.data.data;
                  sessionStorage.setItem("userinfone", JSON.stringify(shuiji));
                  this.$router.push("/Tagent/general/uphome");
                } else {
                  this.$message.error(res.data.msg);
                  this.abcou();
                }
              })
              .catch(function (err) { });
          } else {
            this.$message.error(res.data.msg);
            this.abcou();
          }
        })
        .catch(function (err) { });
    },
  },
};
</script>
<style scoped>
::v-deep .el-input__inner {
  height: 6.0rem;
  line-height: 6.0rem;
}

::v-deep .el-input__prefix {
  display: flex;
  align-items: center;
}

::v-deep .el-input__inner {
  border-radius: 2rem;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 8rem;
  font-size: 2.2rem;
  color: #C5C9C5;
  height: 7rem;
  line-height: 7rem;
}

.el-form-item {
  box-shadow: 0 .4rem 1.6rem 0rem rgba(98, 128, 108, 0.2);
  border-radius: 2rem;
  margin-bottom: 3rem;
}

#app {
  overflow: hidden !important;
}

.iconfont {
  color: #A6CDAC;
  font-size: 3rem;
  margin: 0 3rem 0 2rem;
}


.container {
  margin: 0;
  padding: 0;
  height: 108rem;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.head {
  width: 100%;
  padding: 2rem 5rem 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.head-l,
.head-r {
  display: flex;
  align-items: center;
}

.head-l img {
  width: 21rem;
  height: 2.9rem;
}

.l-line {
  width: 1px;
  height: 1.6rem;
  background: #333;
  margin: 0 1rem 0 3.5rem;
}

.head-l span {
  color: #333;
  font-size: 1.6rem;
}

.head-r span {
  color: #333;
  font-size: 1.6rem;
  cursor: pointer;
}

.head-r span:nth-child(2) {
  margin: 0 5rem;
}

.ziXun {
  color: #fff;
  padding: 0.9rem 1.5rem;
  font-size: 1.8rem;
  background: #49B372;
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.ziXun span {
  color: #fff;
  font-size: 1.6rem;
}

.main {
  width: 83.5rem;
  padding: 8rem 8rem 0 0;
  float: right;
}

.body {
  padding: 14.5rem 12.8rem 10rem;
  background: #fff;
  box-shadow: 0rem .2rem 2rem -0.3rem rgba(0, 0, 0, 0.2);
  border-radius: 2rem;
  backdrop-filter: blur(1rem);
}

.b_title {
  display: flex;
  align-items: center;
  margin-bottom: 5rem;
}

.b_title p:nth-child(1) {
  width: 1rem;
  height: 4rem;
  background: #49B372;
  border-radius: .9rem;
  margin-right: 3rem;
}

.b_title p:nth-child(2) {
  font-size: 4.2rem;
  font-weight: 500;
  color: #000000;
  line-height: 5.9rem;
}

.login-code {
  position: absolute;
  top: 46rem;
  right: 14rem;
}

.login-code img {
  width: 18rem;
}

.login-btn {
  background: linear-gradient(136deg, #59C385 0%, #3EA866 100%) !important;
  box-shadow: 0 .7rem 1rem 0 rgba(73, 179, 114, 0.5), 0 -0.7rem 1rem 0 rgba(255, 255, 255, 0.5);
  border-radius: 2rem;
  font-size: 2.4rem;
  font-weight: 500;
  color: #FFFFFF !important;
  line-height: 3.3rem;
  padding: 1.9rem 22rem !important;
  margin: 5rem 0 2rem;
}

.forget {
  font-size: 1.8rem;
  font-weight: 500;
  color: #49B372;
  line-height: 2.5rem;
}

.footer {
  margin-top: 5rem;
  text-align: center;
}

.footer-t {
  margin-bottom: 2rem;
}

.footer-ul {
  width: 59.1rem;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}

.footer-ul li,
.footer-ul li a {
  color: #333;
  font-size: 1.4rem;
}

.footer-b {
  color: #333;
  font-size: 1.2rem;
}
</style>

